import styles from './Footer.module.scss';

const Footer = () => {
  return (
    <>
      {/* footer */}
      <div className={`footer-container ${styles.footerContainer}`}>
        <div className={`${styles.footerContent}`}>
          <div className={`${styles.privacyContent}`}>
            <div>
              <a
                href="https://www.arre.co.in/terms-of-Use/"
                target={'_blank'}
                rel={'noreferrer'}
                className="hover:underline"
              >
                Terms of Use
              </a>
            </div>
            <div>
              <a
                href="https://www.arre.co.in/arre-voice-privacy-policy/"
                target={'_blank'}
                rel={'noreferrer'}
                className="hover:underline"
              >
                Privacy Policy
              </a>
            </div>
            <div>
              <a
                href="https://arrevoice.notion.site/Self-Regulation-fde7fd3fd1a549ed8ce8c76e52b7f182"
                target={'_blank'}
                rel={'noreferrer'}
                className="hover:underline"
              >
                Self Regulation
              </a>
            </div>
          </div>
          <div className={`${styles.footerDivider}`}>
            <img alt="Footer Divider.img" src={'/assets/images/divider.svg'} width={'100%'} height={'100%'} />
          </div>
          <div className={`${styles.footerSocialIcons}`}>
            <a
              href="https://twitter.com/ArreVoice/"
              target={'_blank'}
              rel={'noreferrer'}
              className={`${styles.footerSocialIcon}`}
            >
              <img alt="Twitter Logo" src={'/assets/logos/twitterLogo.svg'} width={'100%'} height={'100%'} />
            </a>
            <a
              href="https://www.instagram.com/arre_voice/"
              target={'_blank'}
              rel={'noreferrer'}
              className={`${styles.footerSocialIcon}`}
            >
              <img alt="Instagram Logo" src={'/assets/logos/instaLogo.svg'} width={'100%'} height={'100%'} />
            </a>
            <a
              href="https://www.facebook.com/arrevoice/"
              target={'_blank'}
              rel={'noreferrer'}
              className={`${styles.footerSocialIcon}`}
            >
              <img alt="Facebook Logo" src={'/assets/logos/fbLogo.svg'} width={'100%'} height={'100%'} />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
